import Http from 'utils/Http';

export const remotesApi = {
    getRemotes: () => Http.get('product-modules/remotes?lang=fr_FR'),
};
